import styled from 'styled-components';
import { Stack, Tooltip, Typography } from '@mui/material';
import { ReactComponent as InfoIcon } from '../../assets/info-icon.svg';
import OverflowTooltip from '../OverflowTooltip';

const Box = styled(Stack)`
  width: 100%;
  background: ${({ theme }) => theme.palette.common.gray3};
  flex: 1;
  gap: 8px;
  padding: 16px 24px;
  border-radius: 6px;
`;

type Props = {
  title: string;
  description: string | undefined;
  path: string;
  owners: string[];
  tags: string[];
  chipsPanel?: React.ReactNode;
};

const PageOverviewBox = ({
  title,
  description,
  path,
  owners,
  tags,
  chipsPanel,
}: Props) => (
  <Box>
    <Stack direction="row" sx={{ justifyContent: 'space-between', gap: 2 }}>
      <Stack
        direction="row"
        sx={{ gap: 1, alignItems: 'center', overflow: 'hidden' }}
      >
        <OverflowTooltip variant="h5">{title}</OverflowTooltip>
        {description && (
          <Tooltip title={description}>
            <Stack>
              <InfoIcon />
            </Stack>
          </Tooltip>
        )}
      </Stack>
      {chipsPanel}
    </Stack>
    <Stack direction="row" sx={{ gap: 7, overflow: 'hidden' }}>
      <Typography sx={{ whiteSpace: 'nowrap' }}>{`Owners: ${
        owners.join(', ') || '-'
      }`}</Typography>
      <Typography sx={{ whiteSpace: 'nowrap' }}>{`Tags: ${
        tags.join(', ') || '-'
      }`}</Typography>
      <OverflowTooltip>{`Path: ${path}`}</OverflowTooltip>
    </Stack>
  </Box>
);
export default PageOverviewBox;
